import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useFetch } from '@/modules/core/composables/useFetch'

export interface Individual {
  id: string
}
export interface TaxDocument {
  id: string
  shareholder: {
    id: string
    name: string
    type: string
  }
  tax_year: number
}

export interface IndividualExpanded extends Individual {
  tax_documents: TaxDocument[]
}

export const useIndividualStore = defineStore('individualStore', () => {
  const individual = ref<IndividualExpanded>(null)

  /////////////////////////////////////////////////////////////////////////////
  // Actions
  /////////////////////////////////////////////////////////////////////////////

  const fetchTaxDocuments = async (
    individualId: string,
    { slug, shareholder_cids }: { slug: string; shareholder_cids?: string[] },
  ) => {
    const params = new URLSearchParams()
    if (shareholder_cids?.length) {
      params.set('shareholder_cids', shareholder_cids.join(','))
    }

    const queryParams = params.toString() ? `?${params}` : ''
    const data = await useFetch(`/v4/${slug}/tax/individuals/${individualId}/documents${queryParams}`).get<
      TaxDocument[]
    >()
    individual.value = {}
    individual.value.tax_documents = data
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  const createGet = <T>(key: string) => {
    return (id: string): T => {
      return individual.value?.[key]?.find((item: T) => item.id.toString() === id.toString())
    }
  }
  const createList = <T>(key: string): T[] => individual.value?.[key] ?? []
  const createComputedList = <T>(key: string) => computed<T[]>(() => createList<T>(key))

  ///////////////////////////////////////////////////////////////////////////////
  // Tax Documents
  ///////////////////////////////////////////////////////////////////////////////

  const getTaxDocument = createGet<TaxDocument>('tax_documents')
  const listTaxDocuments = createComputedList<TaxDocument>('tax_documents')

  ///////////////////////////////////////////////////////////////////////////////

  return {
    // State
    individual,

    // Actions
    fetchTaxDocuments,

    // Getters

    getTaxDocument,
    listTaxDocuments,
  }
})
